import { cardsData } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新爆料</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">每日精选最劲爆的娱乐圈黑料和内幕，一手资讯，火速送达</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 3).map((card) => (
            <article
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {card.category}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-xs font-medium">{card.tag}</span>
                  <span className="text-xs text-foreground-500">{card.date}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2">{card.summary}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {cardsData.slice(3).map((card) => (
            <article
              key={card.id}
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative sm:w-64 shrink-0">
                <div className="aspect-[16/10] sm:h-full">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {card.category}
                </span>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-xs font-medium">{card.tag}</span>
                  <span className="text-xs text-foreground-500">{card.date}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2">{card.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}